var util = require('../lib/util.es6');
var re = require('../lib/re.es6');


// Wrapper for shitty jQuery UI plugin
var SelectAutoComplete = Backbone.View.extend({
    initialize: function (options) {
        _.bindAll(this, '_optionMapper', '_source');
        this.options = $.extend({
            className: options.className,
            appendTo: options.appendTo,
            optionMapper: this._optionMapper,
            selectItem: $.noop,
            selectTerm: $.noop,
            footer: $.noop
        }, options);
        this.visible = true;
    },
    setValue: function (value) {
        this.input.val(value);
    },
    render: function () {
        $(this.el).hide();
        var selected = $(this.el).children(":selected");
        var inputName = $(this.el).attr('name');
        $(this.el).removeAttr('name');
        this.input = $('<input class="input">');
        if (this.options.className) {
            this.input.addClass(this.options.className + 'Select');
        }
        this.input.attr('placeholder', this.$('.placeholder').text());
        this.input.attr('name', inputName);
        if (!selected.is('.placeholder')) {
            this.setValue(selected.text());
        }
        $(this.el).after($('<div>').append(this.input));
        
        this._setupAutocomplete();
        
        this.button = $('<span class="dropdown">▼</span>')
            .attr("tabIndex", -1)
            .attr("title", "Show All Items")
            .insertAfter(this.input);
        this._setupRevealButton();
    
        var input = this.input;
        this.autocomplete._resizeMenu = function () {
            this.menu.element.outerWidth(input.outerWidth());
        };
        
        return this;
    },
    focus: function () {
        this.input.focus().select();
    },
    hide: function () {
        this.autocomplete.close();
        this.visible = false;
        this.input.hide();
        this.button.hide();
    },
    show: function () {
        this.visible = true;
        this.input.show();
        this.button.show();
    },
    isVisible: function () {
        return this.visible;
    },
    item: function () {
        return this.autocomplete.selectedItem;
    },
    select: function (item) {
        this.autocomplete.selectedItem = item;
    },
    _setupAutocomplete: function () {
        this.input.autocomplete({
            messages: {
                results: _.noop,
                noResults: _.noop
            },
            delay: 0,
            minLength: 0,
            appendTo: this.options.appendTo,
            source: this._source,
            position: {
                my: 'left top-3'
            },
            open: _.bind(function (event, ui) {
                var menu = this.autocomplete.menu;
                menu.next(event);
            }, this),
            select: _.bind(function (event, ui) {
                this.button.removeClass('focusDropdown');
                if (ui.item.option) {
                    ui.item.option.prop('selected', true);
                }
                this.options.selectItem(event, ui.item);
            }, this),
            change: _.bind(function (event, ui) {
                this.button.removeClass('focusDropdown');
                var val = this.input.val();
                if (val && !this.results(val).length) {
                    $(this.el).children("option").prop('selected', false);
                    this.options.selectTerm(event, val);
                }
            }, this)
        });
        this.autocomplete = this.input.data("ui-autocomplete");
        this.autocomplete.term = this.input.val();
        this.autocomplete._renderItem = function (list, item) {
            var li = $("<li>").data("ui-autocomplete-item", item);
            if (item.className) {
                li.addClass(item.className);
            }
            li.append($("<a>").html(item.label));
            list.append(li);
            return li;
        };
    },
    _setupRevealButton: function () {
        this.input.focus(_.bind(function () {
            this.button.addClass('focusDropdown');
        }, this));
        this.input.blur(_.bind(function () {
            this.button.removeClass('focusDropdown');
        }, this));
        this.button.on('click', _.bind(function () {
            this.input.focus();
            // pass empty string as value to search for, displaying all results
            this.autocomplete.search("");
            this.input.focus();
            return false;
        }, this));
    },
    _optionMapper: function (option, term, matcher) {
        var el = $(option);
        var label = el.text();
        if (label && (!term || label.match(matcher))) {
            return {
                label: util.highlightTerm(label, term),
                value: label
            };
        }
    },
    results: function (term) {
        var matcher = new RegExp(re.escape(term), "i");
        return $(this.el).children("option").map(_.bind(function (i, option) {
            return this.options.optionMapper(option, term, matcher);
        }, this));
    },
    _source: function (request, response) {
        var results = this.results(request.term);
        var footer = this.options.footer(request.term);
        if (footer) {
            results.push(footer);
        }
        response(results);
    }
});


module.exports = SelectAutoComplete;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/selectautocomplete.js
// module id = cgtr
// module chunks = 1